import { useCallback } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap'

function ConfirmModal ({ isOpen, toggle, confirm, title = 'Are you sure?', description, text = 'Confirm', color = 'primary' }) {
  const handleConfirm = useCallback(() => {
    toggle()
    confirm()
  }, [toggle, confirm])

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      modalTransition={{ timeout: 0 }}
      backdropTransition={{ timeout: 0 }}
    >
      <ModalHeader tag='h2' close={<i className='close fa fa-close cursor-pointer' onClick={toggle} />}>
        {title}
      </ModalHeader>
      <div>
        {description &&
          <ModalBody>
            {description}
          </ModalBody>}
        <ModalFooter>
          {confirm && <Button color={color} size='lg' onClick={handleConfirm}>{text}</Button>}
          <Button size='lg' onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.string
}

export default ConfirmModal
